// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_m2-0";
export var buttonContainer = "_m2-3";
export var cancelButton = "_m2-4";
export var headerSection = "_m2-6";
export var headerTitle = "_m2-9";
export var messageSideLeft = "_m2-1";
export var messageSideRight = "_m2-2";
export var orderNumberContainer = "_m2-7";
export var orderNumberLabel = "_m2-8";
export var submitButton = "_m2-5";